
export class ChipsearnerVO {
    public index: number = 0;
    public chips: number = NaN;
}
